import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "blog-index" }
const _hoisted_2 = { class: "blog-index__categories" }
const _hoisted_3 = { class: "blog-index__categories-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "blog-index__category-label" }, "All", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = { class: "blog-index__category-count" }
const _hoisted_7 = { class: "blog-index__category-label" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = { class: "blog-index__category-count" }
const _hoisted_10 = { class: "blog-index__articles" }

import { onMounted, ref, computed, watch } from 'vue';
import { bind } from '@drapejs/core';
import useCache from '@/composables/useCache';
import useContext from '@/composables/useContext';
import useMeta from '@/composables/useMeta';

import BlogArticleItem from '@/components/BlogArticleItem.vue';


import { defineComponent, onServerPrefetch } from 'vue';

const __default__ = defineComponent({
  name: 'BlogIndex'
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { page, route } = useContext();
const { subscribe, getItem, getServerItem } = useCache();
const meta = useMeta();

const articles = bind('__blog');

const selectedCategory = ref(route.hash);

const filtered = computed(() => {
  if (!articles.value) { return []; }
  let result = Object.values(articles.value);
  if (selectedCategory.value) {
    result = Object.values(articles.value)?.filter((a: any) => a.category === selectedCategory.value);
  }
  result.sort((a: any, b: any) => {
    const ad = Date.parse(a.first_published_at);
    const bd = Date.parse(b.first_published_at);
    return ad < bd ? 1 : -1;
  });
  return result;
});

const categories: any = computed(() => {
  if (!articles.value) return {};
  return Object.values(articles.value).reduce((res: any, item: any) => {
    res[item.category] = res[item.category] ? res[item.category] + 1 : 1;
    return res;
  }, {});
});

const totalCount = computed(() => {
  if (!articles.value) return 0;
  return Object.keys(articles.value).length;
});

watch(() => route.hash, (hash) => {
  selectedCategory.value = hash;
});

const pad = (val: number) => {
  return val.toString().padStart(2, '0');
}

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_blocks_repeater, {
      blocks: _unref(page).blocks
    }, null, 8, ["blocks"]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: `${_unref(route).pathname}`,
          class: _normalizeClass(["blog-index__categories-link", {'blog-index__categories-link--selected': !selectedCategory.value }])
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(pad(_unref(totalCount))), 1)
          ]),
          _: 1
        }, 8, ["to", "class"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (count, label) => {
        return (_openBlock(), _createElementBlock("li", {
          key: label,
          class: "blog-index__categories-item"
        }, [
          _createVNode(_component_router_link, {
            to: `${_unref(route).pathname}#${label}`,
            class: _normalizeClass(["blog-index__categories-link", {'blog-index__categories-link--selected': selectedCategory.value == label }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(label), 1),
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(pad(count)), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filtered), (article) => {
        return (_openBlock(), _createBlock(BlogArticleItem, {
          key: article._uid,
          article: article
        }, null, 8, ["article"]))
      }), 128))
    ])
  ]))
}
}

})